module.exports = __webpack_public_path__ + "media/images/riders/JOE_SMITH-136409f2cb50cb147d829641aebd7a98.png";